import { connect } from 'react-redux';
import FreshsalesView from './FreshsalesView.jsx';
import { getIntegrationForType, fetchIntegrations } from 'src/legacy/redux/actions/integrations.jsx';
import { fetchFreshsalesIntegration} from 'src/legacy/redux/actions/integrations/freshsales.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'freshsales');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
    user: state.users.me
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchFreshsalesIntegration: () => {
      return dispatch(fetchFreshsalesIntegration());
    },

    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    }
  }
}

const FreshsalesPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(FreshsalesView);

export default withUseHooks(FreshsalesPage);
